export default __webpack_public_path__ + "static/media/anniversarymob4.430ce714.webp";